import { initContract } from "@ts-rest/core";
import { z } from "zod";

import { PermissionSchema } from "../generated/prisma/zod";

const c = initContract();

export const permissionsContract = c.router({
  findAll: {
    method: "GET",
    path: "/permissions",
    responses: {
      200: PermissionSchema.extend({
        enabled: z.boolean(),
      }).array(),
    },
  },
});
